import React from 'react';
import { FaNewspaper, FaCogs, FaUsers, FaEye, FaChartLine, FaArrowUp } from 'react-icons/fa';
import { artikelData, layananData } from '../data/adminData';

const Dashboard = () => {
    const stats = [
        { title: 'Total Artikel', value: artikelData.length, icon: FaNewspaper, color: 'from-blue-500 to-blue-700', change: '+12%' },
        { title: 'Layanan Aktif', value: layananData.filter(l => l.status === 'active').length, icon: FaCogs, color: 'from-green-500 to-green-700', change: '+5%' },
        { title: 'Pengunjung Hari Ini', value: '1,234', icon: FaUsers, color: 'from-purple-500 to-purple-700', change: '+18%' },
        { title: 'Total Views', value: '45,678', icon: FaEye, color: 'from-orange-500 to-orange-700', change: '+24%' }
    ];

    return (
        <div>
            <h1 className="text-2xl font-bold text-[#0F172A] mb-6">Dashboard</h1>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                {stats.map((stat, index) => (
                    <div key={index} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
                        <div className="flex items-center justify-between mb-4">
                            <div className={`w-12 h-12 bg-gradient-to-br ${stat.color} rounded-lg flex items-center justify-center`}>
                                <stat.icon className="text-white text-xl" />
                            </div>
                            <span className="text-green-500 text-sm flex items-center">
                                <FaArrowUp className="mr-1" /> {stat.change}
                            </span>
                        </div>
                        <h3 className="text-2xl font-bold text-[#0F172A]">{stat.value}</h3>
                        <p className="text-gray-500 text-sm mt-1">{stat.title}</p>
                    </div>
                ))}
            </div>

            {/* Recent Articles */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-8">
                <h3 className="text-lg font-bold text-[#0F172A] mb-4">Artikel Terbaru</h3>
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                            <tr className="text-left text-sm text-gray-500 border-b">
                                <th className="pb-3">Judul</th>
                                <th className="pb-3">Kategori</th>
                                <th className="pb-3">Status</th>
                                <th className="pb-3">Tanggal</th>
                            </tr>
                        </thead>
                        <tbody>
                            {artikelData.slice(0, 5).map((artikel) => (
                                <tr key={artikel.id} className="border-b last:border-0">
                                    <td className="py-3 text-sm font-medium text-gray-700">{artikel.judul}</td>
                                    <td className="py-3">
                                        <span className="bg-blue-50 text-blue-600 text-xs px-2 py-1 rounded-full">
                                            {artikel.kategori}
                                        </span>
                                    </td>
                                    <td className="py-3">
                                        <span className={`text-xs px-2 py-1 rounded-full ${artikel.status === 'published'
                                                ? 'bg-green-50 text-green-600'
                                                : 'bg-yellow-50 text-yellow-600'
                                            }`}>
                                            {artikel.status}
                                        </span>
                                    </td>
                                    <td className="py-3 text-sm text-gray-500">{artikel.tanggal}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Recent Layanan */}
            <div className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="text-lg font-bold text-[#0F172A] mb-4">Layanan Aktif</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {layananData.filter(l => l.status === 'active').slice(0, 3).map((layanan) => (
                        <div key={layanan.id} className="border rounded-lg p-4 hover:border-[#0D9488] transition-colors">
                            <div className="text-3xl mb-2">{layanan.icon}</div>
                            <h4 className="font-semibold text-gray-700">{layanan.nama}</h4>
                            <p className="text-sm text-gray-500 mt-1">{layanan.deskripsi}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Dashboard;